<template>
    <div class="mb-4 bg-white rounded-lg p-[16px] w-full overflow-hidden">
            <h2 class="text-4xl text-[#2b2b2b]">Payroll</h2>

            <div class="my-6 flex items-center justify-between">
                <div class="w-[250px] flex flex-col items-start ">
                    <div class="h-[35px] text-black font-light cursor-pointer w-full rounded-xl border outline-none p-3 focus:outline-none">
                        <span>Période : {{ convertirDate(periode) }}</span>
                    </div>
                </div>
                <div class="flex items-center justify-end gap-x-3">
                    <div class="inline-block relative">
                        <button v-on:click="show = true" class="rounded-xl px-8 h-[35px] border font-light text-white bg-[#3c41e9] flex items-center gap-x-2 relative"><ArrowUpFromLine :size="18" strokeWidth="1.2"/> Générer</button>
                        <Transition
                            name="popup-animation"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @leave="leave"
                            >
                            <div v-if="show" id="generator" class="absolute min-w-[300px] text-black rounded-lg p-6 top-[110%] shadow-lg border right-0 bg-white">
                                <div class="flex justify-between items-center">
                                    <h3 class="font-extralight">Choisir le mois</h3>
                                    <X color="#000" strokeWidth="1.2" :size="18" class="cursor-pointer" v-on:click="show = false"/>
                                </div>
                                <div class="flex flex-col gap-y-3 mt-4">
                                    <input type="month" v-model="month" class="w-full h-[40px] rounded-lg border cursor-pointer px-5">
                                    <button v-on:click="getData" :disabled="asSend" class="w-full rounded-lg text-white h-[40px] bg-[#3c41e9] font-light">
                                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                        <span v-if="!asSend">Charger</span>
                                    </button>
                                    <div class="w-full">
                                        <CustomTable :data="employees" :columnsCustom="columnn" :load="table_load">
                                            <template #other-filter>
                                                {{ selectedUser.length != 0 ?  (selectedUser.length > 1 ? selectedUser.length + " employés sélectionnés" : selectedUser.length + " employé sélectionné") : "" }}
                                            </template>
                                            <template #row-cell="slotProps">
                                                <span v-if="slotProps.cellNumber == 0" class="flex items-center px-6">
                                                    <input type="checkbox" :value="Number(slotProps.value)" v-model="selectedUser" class="size-[16px] cursor-pointer static opacity-100 mb-1"/>
                                                </span>
                                                <span v-else-if="slotProps.cellNumber == 2">
                                                    <div class="flex items-center gap-x-[6px]">
                                                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                                                        <div class="flex flex-col items-start">
                                                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                                                            <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span v-else>{{ slotProps.value }}</span>
                                            </template>
                                        </CustomTable>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    </div>
                <button class="rounded-xl px-8 h-[35px] border font-light text-black flex items-center gap-x-2"><FolderUp :size="18" strokeWidth="1.2"/> Exporter</button>
                </div>
            </div>

            <div class="p-2 flex items-center gap-x-2 rounded-lg bg-[#eef1fb] border border-[#d1dbe8] text-[12px] font-extralight text-black">
                <Info :size="15" strokeWidth="1.6" fill="#3772f5" color="#fff"/> Pour afficher l'historique de paiement sur une période donné vous devez cliqué sur le bouton <span class="underline cursor-pointer" v-on:click="show = true">"Générer"</span> ci-dessus
            </div>

            <div class="rounded-lg p-4 my-6 border">
                <div class="flex items-center gap-x-2 text-black font-light rounded-md">
                    <span v-bind:class="getActiveClass('Historique')" v-on:click="selectBar('Historique')">Historique</span>
                    <span v-bind:class="getActiveClass('Livre de paie')" v-on:click="selectBar('Livre de paie')">Livre de paie </span>
                </div>
            </div>

            <div v-if="getActiveTab('Historique')" class="w-full">
                <div class="border rounded-lg">
                        <div class="body">
                            <template v-if="!load">
                                <div class="text-black p-6 flex items-center justify-between">
                                    <h2 class="font-extralight text-[18px]">Historique</h2>

                                    <div class="flex items-center gap-x-3">
                                        <button v-on:click="getCharge" :disabled="asSend3" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
                                            <BookMarked v-if="!asSend3" :size="16" strokeWidth="1.2"/> 
                                            <Loader2 v-else :size="16" strokeWidth="1.2"/>
                                            Charge patronal
                                        </button>

                                        <button :disabled="loadedData.length == 0" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
                                            <Send :size="16" strokeWidth="1.2"/> Envoyer en masse
                                        </button>
                                    </div>
                                </div>
                                <template v-if="loadedData.length != 0">
                                    <table class="w-full rounded-b-lg text-black border-none table-hover js-exportable tableExceptionClassement">
                                        <thead>
                                            <tr class="bg-[#e9edf1] h-[55px]">
                                                <th class="font-extralight pl-3">Id</th>
                                                <th class="font-extralight">Nom employé</th>
                                                <th class="font-extralight">Salaire base</th>
                                                <th class="font-extralight">Sursalaire</th>
                                                <th class="font-extralight">Gratification</th>
                                                <th class="font-extralight">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dt in loadedData" :key="dt.matricule" class="bg-[#f5f8fa] h-[65px] border-b border-b-[#eaedef]">
                                                <th class="font-extralight pl-3">{{ dt.matricule }}</th>
                                                <th class="font-extralight">{{ dt.nom_prenom }}</th>
                                                <th class="font-extralight">{{ dt.salaire_de_base }}</th>
                                                <th class="font-extralight">{{ dt.sursalaire }}</th>
                                                <th class="font-extralight">{{ dt.gratification }}</th>
                                                <th class="font-extralight">
                                                    <loadDocument :data="dt" :month="month"/>
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                                <div v-else class="w-full h-[20vh] flex items-center justify-center">
                                    <div class="flex flex-col items-center gap-y-2 text-black">
                                        <Ban strokeWidth="1.2" :size="26"/>
                                        <span class="font-extralight">Aucune donné pour <span class="underline">{{ convertirDate(periode) }}</span></span>
                                    </div>
                            </div>
                            </template>
                            <template v-else>
                                <div class="text-black w-full h-[20vh] flex items-center justify-center">
                                    <span class="font-extralight">Chargement...</span>
                                </div>
                            </template>
                        </div>
                </div>
            </div>

            <div v-if="getActiveTab('Livre de paie')" class="w-full">
                <div class="border rounded-lg w-full">
                        <div class="body w-full">
                            <template v-if="!load">
                                <div class="text-black p-6 flex items-center justify-between">
                                    <h2 class="font-extralight text-[18px]">Livre de paie</h2>

                                    <button v-on:click="generateExcelFile" :disabled="loadedData.length == 0" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
                                        <BookText :size="16" strokeWidth="1.2" v-if="!loadGetPaylist"/> <Loader2 v-else :size="16" strokeWidth="1.2" class="animate-spin mx-auto"/>Obtenir le livre de paie
                                    </button>
                                </div>
                                <template v-if="loadedData.length != 0">
                                    <div class="overflow-x-auto">
                                        <table class=" w-full rounded-b-lg text-black border-none table-hover">
                                        <thead>
                                            <tr class="bg-[#e9edf1] h-[55px]">
                                                <th class="font-extralight px-8 text-center">Mat</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Nom & Prénoms</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Salaire de base ou catégoriel</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Sursalaire</th>
                                                <th class="font-extralight px-8 text-center w-[100px]">Déduction</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Prime <br>d'anciennette</th>
                                                <th class="font-extralight px-8 text-center w-[100px]">Heures Suppl <br>Remu</th>

                                                <th class="font-extralight px-8 text-center w-[100px]">Congés</th>
                                                <th class="font-extralight px-8 text-center w-[170px]">Prim., indem. <br>et gratif. <br>imposables</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Brut <br>imposable</th>
                                                <th class="font-extralight px-8 text-center w-[170px]">Primes <br>et indem. <br>nom impos.</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">ITS</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">Caisse <br>de <br>retraite</th>
                                                <th class="font-extralight px-8 text-center w-[150px]">CMU</th>
                                                <th class="font-extralight px-8 text-center w-[180px]">Avance, <br> acpte, autres <br>retenues</th>
                                                <th class="font-extralight px-8 text-center w-[200px]">Net à payer</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dt in loadedData" :key="dt.matricule" class="bg-[#f5f8fa] h-[65px] border-b border-b-[#eaedef]">
                                                <th class="font-extralight pl-3">{{ dt.matricule }}</th>
                                                <th class="font-extralight pl-3">{{ dt.salaire_de_base }}</th>
                                                <th class="font-extralight pl-3">{{ dt.sursalaire }}</th>
                                                <th class="font-extralight pl-3">{{ dt.deduction_sur_salaire }}</th>
                                                <th class="font-extralight pl-3">{{ dt.prime_anciennete }}</th>
                                                <th class="font-extralight pl-3">{{ dt.heures_suppl_remur }}</th>
                                                <th class="font-extralight pl-3">{{ dt.conges_payes_gains }}</th>
                                                <th class="font-extralight pl-3">{{ 0.0 }}</th>
                                                <th class="font-extralight pl-3">{{ dt.total_salaire_brut_imposable }}</th>
                                                <th class="font-extralight pl-3">{{ dt.prime_transport_non_impos }}</th>
                                                <th class="font-extralight pl-3">{{ dt.retenue_its }}</th>
                                                <th class="font-extralight pl-3">{{ dt.conges_payes_gains }}</th>
                                                <th class="font-extralight pl-3">{{ dt.retenue_cmu_employe }}</th>
                                                <th class="font-extralight pl-3">{{ dt.avance_sur_salaire }}</th>
                                                <th class="font-extralight pl-3">{{ dt.cmu_employeur }}</th>
                                                <th class="font-extralight pl-3">{{ dt.total_gross_earnings }}</th>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                    
                                </template>
                                <div v-else class="w-full h-[20vh] flex items-center justify-center">
                                    <div class="flex flex-col items-center gap-y-2 text-black">
                                        <Ban strokeWidth="1.2" :size="26"/>
                                        <span class="font-extralight">Aucune donné pour <span class="underline">{{ convertirDate(periode) }}</span></span>
                                    </div>
                            </div>
                            </template>
                            <template v-else>
                                <div class="text-black w-full h-[20vh] flex items-center justify-center">
                                    <span class="font-extralight">Chargement...</span>
                                </div>
                            </template>
                        </div>
                </div>
            </div>
    </div>
</template>
<script>
import loadDocument from "@/components/create/load-document.vue";
import {
    Loader2,Send,BookText,
    FolderUp,Info,ArrowUpFromLine,X,Ban,BookMarked} from "lucide-vue-next"
// import ApexCharts from "apexcharts"
import gsap from "gsap";
import API from "@/service/API.js";
// import toast from "@/components/ui/toast";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import {createColumnHelper} from "@tanstack/vue-table";
import CustomTable from "@/components/tables/Custom-table.vue";

const columnHelper = createColumnHelper();
const columnsRequest = [
    columnHelper.accessor(row => row.id, {
    id: 'action',
    header: '',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.matricule, {
    id: 'matricule',
    header: 'Matricule',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.first_name}/${row.last_name}/${row.email}`, {
    id: 'employé',
    header: 'Employé',
    cell: info => info.getValue(),
  }),
];


export default {
    name: "PayrollView",
    components:{
        Loader2,
        Send,BookText,
        loadDocument,
        ArrowUpFromLine,X,Ban,
        FolderUp,Info,BookMarked,CustomTable,},
    data(){
        return {
            load:true,
            show: false,
            asSend3: false,
            loadedData:[],
            selectedUser:[],
            loadGetPaylist:false,
            periode:"",
            table_load:false,
            month:null,
            employees:[],
            asSend: false,
            active: "Historique",
            columnn: columnsRequest,
        }
    },
    
    mounted(){
        // this.initChart();
        this.reloadDataList(this.periode);
        this.getEmployeData();
    },
    created(){
        this.periode = this.obtenirDateActuelleFormatAAAA_MM();
    },
    methods:{
        getActiveTab(libelle){
            return this.active == libelle
        },
        getActiveClass(libelle){
            return `px-4 py-3 rounded-md cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-[#f9fafb] text-black"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        // initChart(){
        //     var chart = new ApexCharts(document.querySelector("#chart"), this.options);
        //     chart.render();
        // },
        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) {
                view[i] = s.charCodeAt(i) & 0xFF;
            }
            return buf;
        },
        getCharge(){
            this.asSend3 = true;
            API.post("payroll/charges",{"month": this.month})
            .then((res)=>{
                if(res.data.status != "success") throw Error(res.data.message);
                const header = ["Matricule","Nom & Prenom","Retenue cnps","Retenue Its","Retenue Cmu Employée","Mutuelle","Avance Sur Salaire","Pret Long Terme","Pret Scolaire","Total Des Retenues","Its Part Patronale","Cnps Part Patronale","Cnps Accident Travail","Cnps Prest Famil","Fdfp Taxe Apprentissage","Fdfp Form Prof Continue","Cmu Employeur","Total Charges Patronales","Total Global Charges"];
                //const header2 = ["N°","NOMS ET PRENOMS","SALAIRE BRUTS IMPOSABLES"];
                const chargePatronale = [header];
                res.data.entries.forEach((emplo)=>{
                    const tab = [
                        emplo["matricule"],
                        emplo["nom_prenom"],
                        emplo["retenue_cnps"],
                        emplo["retenue_its"],
                        emplo["retenue_cmu_employe"],
                        emplo["mutuelle"],
                        emplo["avance_sur_salaire"],
                        emplo["pret_long_terme"],
                        emplo["pret_scolaire"],
                        emplo["total_des_retenues"],
                        emplo["its_part_patronale"],
                        emplo["cnps_part_patronale"],
                        emplo["cnps_accident_travail"],
                        emplo["cnps_prest_famil"],
                        emplo["fdfp_taxe_apprentissage"],
                        emplo["fdfp_form_prof_continue"],
                        emplo["cmu_employeur"],
                        emplo["total_charges_patronales"],
                        emplo["total_global_charges"]
                    ];
                    chargePatronale.push(tab);
                })
                const worksheet = XLSX.utils.aoa_to_sheet(chargePatronale);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Charge_patronal"+"_"+this.month);
                const xlsx = XLSX.write(workbook, {type: "binary", bookType: "xlsx"});

                const arrayBuffer = this.s2ab(xlsx);
                const blob = new Blob([arrayBuffer], { type: "application/octet-stream" });

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = res.data.title.split(" ").join("_") + "_" + this.month + ".xlsx";
                link.click();
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.asSend3 = false)
        },
        getEmployeData() {
            this.table_load = true;
            API.get('getAllEmployees')
                .then((res) => {
                    if(!res.data.status) throw Error(res.data.message ?? "Erreur sur le serveur");
                    this.employees = res.data.data;
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{
                    this.table_load = false
                })
        },
        getData(){
            if(!this.month){
                Swal.fire('Erreur!!!!',"Veuillez choisir le mois",'error');
            }
            this.asSend = true;
            API.post("payroll/payslips",{"month": this.month,"include_overtime": true,exempted:[...this.selectedUser]})
            .then((res)=>{
                if(res.status != 200) throw Error(res.data.message);
                this.periode = this.month;
                this.reloadDataList(this.month);
                this.selectedUser = [];
                Swal.fire('Succès!!!!',"Donnée chargé avec succès",'success');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.asSend = false);
        },
        reloadDataList(month){
            this.load = true;
            API.post("payroll/book",{month})
            .then((res)=>{
                if(res.status != 200) throw Error(res.data.message);
                this.loadedData = res.data.entries;
                Swal.fire('Succès!!!!',"Les données on été actualiser",'success');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>this.load = false);
        },
        convertirDate(dateString) {
            const [annee, mois] = dateString.split('-');
            const nomsMois = [
                "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
            ];
            const nomMois = nomsMois[parseInt(mois, 10) - 1];
            return `${nomMois} ${annee}`;
            },
        obtenirDateActuelleFormatAAAA_MM() {
            const date = new Date();
            const annee = date.getFullYear();
            const mois = ('0' + (date.getMonth() + 1)).slice(-2);
            return `${annee}-${mois}`;
        },
        beforeEnter(el){
            gsap.set(el, {
                opacity: 0,
                y: 10,
            });
        },
        enter(el, done){
            gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: 0.15,
                ease: "back.out(1.7)",
                onComplete: done,
            });
        },
        leave(el, done){
            gsap.to(el, {
                opacity: 0,
                y: 10,
                duration: 0.15,
                ease: "power2.in",
                onComplete: done,
            });
        },
        generateExcelFile(){
            try{
                this.loadGetPaylist = true;
                const data = [];
                for (const dt of this.loadedData) {
                    data.push({
                        "Mat":dt.matricule,
                        'Nom & Prénoms':dt.salaire_de_base,
                        'Salaire de base ou catégoriel':dt.sursalaire,
                        'Sursalaire':dt.deduction_sur_salaire,
                        'Déduction':dt.prime_anciennete,
                        "Prime d'anciennette":dt.heures_suppl_remur,
                        "Heures Suppl Remu":dt.conges_payes_gains,
                        "Congés":0.0,
                        "Prim., indem. et gratif. imposables":dt.total_salaire_brut_imposable,
                        "Brut imposable":dt.prime_transport_non_impos,
                        "Primes et indem. nom impos.":dt.retenue_its,
                        "ITS":dt.conges_payes_gains,
                        "Caisse de retraite":dt.retenue_cmu_employe,
                        "CMU":dt.avance_sur_salaire,
                        "Avance, acpte, autres retenues":dt.cmu_employeur,
                        "Net à payer":dt.total_gross_earnings
                    })
                }
            

                const worksheet = XLSX.utils.json_to_sheet(data);
                const headerStyle = {
                    font: { bold: true, sz: 14, color: { rgb: "FF000000" } },
                    fill: { fgColor: { rgb: "FFC0C0C0" } },
                    alignment: { horizontal: "center", vertical: "center" }
                };

                const footerData = [{
                        "Mat":"Total",
                        'Nom & Prénoms':"",
                        'Salaire de base ou catégoriel':"",
                        'Sursalaire':"",
                        'Déduction':"",
                        "Prime d'anciennette":"",
                        "Heures Suppl Remu":"",
                        "Congés":"",
                        "Prim., indem. et gratif. imposables":"",
                        "Brut imposable":"",
                        "Primes et indem. nom impos.":"",
                        "ITS":"",
                        "Caisse de retraite":"",
                        "CMU":"",
                        "Avance, acpte, autres retenues":"",
                        "Net à payer":""
                    }];

                // Récupérer les en-têtes de colonnes
                const headers = Object.keys(data[0]);

                // --- Personnalisation de l'en-tête (ligne 1) ---
                headers.forEach((header, index) => {
                    const cellRef = XLSX.utils.encode_cell({ c: index, r: 0 });
                    if (worksheet[cellRef]) {
                    worksheet[cellRef].s = headerStyle;
                    }
                });

                const columnWidths = headers.map(()=> ({ wch: 30 }));
                worksheet['!cols'] = columnWidths;

                // // --- Alternance des couleurs pour les lignes de données ---
                const whiteStyle = { fill: { fgColor: { rgb: "FFFFFFFF" } } };
                const greyStyle = { fill: { fgColor: { rgb: "FFC0C0C0" } } };
                for (let i = 0; i < data.length; i++) {
                    const style = (i % 2 === 0) ? whiteStyle : greyStyle;
                    const row = data[i];
                    Object.keys(row).forEach((key, colIndex) => {
                        const cellRef = XLSX.utils.encode_cell({ c: colIndex, r: i + 1 });
                        if (worksheet[cellRef]) {
                            worksheet[cellRef].s = style;
                        }
                    });
                }
                console.log("log 1")
                // // Ajouter la ligne du footer en bas de la feuille
                XLSX.utils.sheet_add_json(worksheet, footerData, { origin: -1, skipHeader: true });

                const footerRowIndex = data.length + 1;
                // const footerStyle = {
                //     font: { bold: true, color: { rgb: "FF000000" } },
                //     fill: { fgColor: { rgb: "FF969696" } },
                //     alignment: { horizontal: "center" }
                // };

                // Appliquer le style à toutes les cellules de la dernière ligne
                // const footerCells = XLSX.utils.encode_range({ s: { c: 0, r: footerRowIndex }, e: { c: headers.length - 1, r: footerRowIndex } });
                // console.log("voir decode range ====>",XLSX.utils.decode_range(footerCells))
                // console.log("footer cell ===> ",footerCells);
                // XLSX.utils.decode_range(footerCells).forEach(cell => {
                //     const cellRef = XLSX.utils.encode_cell(cell);
                //     if (worksheet[cellRef]) {
                //     worksheet[cellRef].s = footerStyle;
                //     }
                // });
                console.log("log 2")
                // // Fusionner les deux premières cellules du footer
                worksheet['!merges'] = [{
                    s: { r: footerRowIndex, c: 0 },
                    e: { r: footerRowIndex, c: 1 }
                }];

                // Créer un classeur et ajouter la feuille
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Bulletin_de_paie_'+this.month);
                this.loadGetPaylist = false;
            }catch(e){
                console.log(e)
            }
            // Générer le fichier binaire
            // const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

            // Créer un Blob et le sauvegarder via file-saver
            // const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            // saveAs(dataBlob, 'rapport_employes.xlsx');
        }
    }
}
</script>